module.exports = __webpack_public_path__ + "static/media/jss.174826bf.jpg";